import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-html5', 'IconBrandHtml5', [
  ['path', { d: 'M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z', key: 'svg-0' }],
  [
    'path',
    { d: 'M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5', key: 'svg-1' },
  ],
]);
